import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import styles from '../../styles/main.scss';

// components
import Text from '../inputs/Text';

const messages = defineMessages({
    placeholder: {
        id: 'dc.AddressForm.State.placeholder',
        defaultMessage: 'State or Region (optional)',
    },
});

const State = ({
    value,
    autoFocus,
    fieldSize,
    isBlurred,
    disabled,
    error,
    onChange,
    onBlur,
    disableAutocomplete,
}) => {
    const intl = useIntl();
    return (
        <Text
            name="state"
            dataTn="state"
            value={value}
            wrapperClass={styles.leftGroup}
            placeholder={intl.formatMessage(messages.placeholder)}
            autoFocus={autoFocus}
            fieldSize={fieldSize}
            isBlurred={isBlurred}
            disabled={disabled}
            disableAutocomplete={disableAutocomplete}
            error={error}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
};

State.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    autoFocus: PropTypes.bool,
    fieldSize: PropTypes.oneOf(['small', 'medium', 'large']),
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    disableAutocomplete: PropTypes.bool,
};

State.defaultProps = {
    autoFocus: false,
    onBlur() {},
};

export default State;
